
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Make sure the DOM is fully loaded before attempting to render
const renderApp = () => {
  const rootElement = document.getElementById("root");
  
  if (!rootElement) {
    console.error("Could not find root element to mount React application");
    return;
  }
  
  try {
    // Log the current hostname for debugging purposes
    console.log("Current hostname:", window.location.hostname);
    
    createRoot(rootElement).render(<App />);
    console.log("React application successfully mounted");
  } catch (error) {
    console.error("Error rendering React application:", error);
  }
};

// If document is already loaded, render immediately
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', renderApp);
} else {
  renderApp();
}
